import React from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import Logo from "@/components/Logo";
import {
  ChartLineUp,
  Users,
  Calendar,
  Vault,
  Receipt,
  Robot,
  SignOut,
} from "@phosphor-icons/react";

const items = [
  { to: "/dashboard", end: true, label: "Overview", icon: ChartLineUp, testId: "nav-overview" },
  { to: "/dashboard/clients", label: "Clients", icon: Users, testId: "nav-clients" },
  { to: "/dashboard/deadlines", label: "Deadlines", icon: Calendar, testId: "nav-deadlines" },
  { to: "/dashboard/documents", label: "Documents", icon: Vault, testId: "nav-documents" },
  { to: "/dashboard/invoices", label: "Invoices", icon: Receipt, testId: "nav-invoices" },
  { to: "/dashboard/assistant", label: "AI Tax Assistant", icon: Robot, testId: "nav-assistant" },
];

const AppShell = ({ children, portalMode = false }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const menu = portalMode
    ? [
        { to: "/portal", end: true, label: "Overview", icon: ChartLineUp, testId: "nav-overview" },
        { to: "/portal/deadlines", label: "My Deadlines", icon: Calendar, testId: "nav-deadlines" },
        { to: "/portal/documents", label: "My Documents", icon: Vault, testId: "nav-documents" },
        { to: "/portal/invoices", label: "My Invoices", icon: Receipt, testId: "nav-invoices" },
        { to: "/portal/assistant", label: "AI Tax Assistant", icon: Robot, testId: "nav-assistant" },
      ]
    : items;

  const doLogout = () => {
    logout();
    nav("/", { replace: true });
  };

  return (
    <div className="min-h-screen grid grid-cols-[240px_1fr] bg-[#FDFCFB]">
      <aside className="border-r border-[#E8EAE8] bg-white flex flex-col">
        <Link to="/" className="p-6 border-b border-[#E8EAE8] block" data-testid="sidebar-logo">
          <Logo size={32} tone="ink" wordmarkClassName="text-lg text-[#0F2E22]" />
        </Link>
        <nav className="flex-1 p-3 space-y-1">
          {menu.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={it.testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm rounded-md transition-colors ${
                  isActive
                    ? "bg-[#0F2E22] text-white"
                    : "text-[#3B463F] hover:bg-[#F3F1EC]"
                }`
              }
            >
              <it.icon size={18} weight="duotone" />
              {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-[#E8EAE8]">
          <div className="text-xs text-[#5C6B64]">Signed in as</div>
          <div className="text-sm font-medium text-[#0F2E22] truncate" data-testid="user-name">{user?.name}</div>
          <div className="text-xs text-[#5C6B64] truncate" data-testid="user-email">{user?.email}</div>
          <button
            onClick={doLogout}
            data-testid="logout-btn"
            className="mt-3 w-full flex items-center justify-center gap-2 border border-[#E8EAE8] py-2 text-sm text-[#3B463F] hover:bg-[#F3F1EC] transition-colors"
          >
            <SignOut size={16} /> Sign out
          </button>
        </div>
      </aside>
      <main className="p-8 max-w-[1400px] w-full">{children}</main>
    </div>
  );
};

export default AppShell;
